export default "__VITE_ASSET__CcqNHSLL__"